import * as translator from "../../../../../utils/translator";

type Props = {
  language: string | undefined;
  displayText: string;
  onUseSuggested: () => void;
  onEnterAnother: () => void;
};

const LocationSuggestionCard: React.FC<Props> = ({ language, displayText, onUseSuggested, onEnterAnother }) => {
  return (
    <div className="flex flex-col items-center pt-7 px-2.5 pb-[19px] gap-7 flex-1 border border-[#11ddac] rounded-lg mx-3">
      <div className="flex flex-col items-center gap-3 text-center w-[315px] max-w-full">
        <p className="font-roboto text-sm font-normal text-[#747474] leading-4 m-0 w-full">
          {translator.translate(language, "shipping", "AddNewAddressModal/location_suggestion_text") || "Based on your location, it looks like you're here:"}
        </p>
        <p className="font-roboto text-base font-semibold text-[#0c0c0d] leading-[18px] m-0 w-full">
          {displayText}
        </p>
      </div>
      <div className="flex flex-col items-center gap-2.5 w-[300px] max-w-full">
        <button
          onClick={onUseSuggested}
          className="flex items-center justify-center gap-2 w-full py-5 px-8 rounded-xl border-none linear-background-color-primary text-white text-base font-medium font-poppins cursor-pointer"
        >
          {translator.translate(language, "shipping", "AddNewAddressModal/use_this_address") || "Use this address"}
        </button>
        <button
          onClick={onEnterAnother}
          className="flex items-center justify-center gap-2 w-full py-5 px-8 rounded-xl border border-[#269c6e] bg-transparent text-[#61a333] text-base font-medium font-poppins cursor-pointer"
        >
          {translator.translate(language, "shipping", "AddNewAddressModal/enter_another_address") || "Enter another address"}
        </button>
      </div>
    </div>
  );
};

export default LocationSuggestionCard;
